const Mag = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlSpace='preserve'
      id='logotipo'
      x={0}
      y={0}
      style={{
        background: 'new 0 0 599.9000244 288.8999634',
      }}
      viewBox='0 0 599.9 288.9'
      width='1em'
      height='1em'
    >
      <style>{'.st0{fill:url(#mag_00000179630817440677785680000017887141015989953666_)}'}</style>
      <linearGradient
        id='mag_00000166670571226290606660000011522640988944400310_'
        x1={0}
        x2={599.9}
        y1={134.932}
        y2={134.932}
        gradientTransform='translate(0 -35.276)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset={0}
          style={{
            stopColor: '#00b3e0',
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#0064af',
          }}
        />
      </linearGradient>
      <path
        id='mag'
        d='m392.7 125.3-91.4 29.2c-.5.2-.9.5-1.1 1l-15.5 38.2c-.4.9.1 1.9 1 2.2.4.2.8.2 1.2 0l80.6-26.2 9.1 24.9c.3.7.9 1.1 1.6 1.1h41c1 0 1.7-.8 1.7-1.7 0-.2 0-.4-.1-.6l-26-67.1c-.3-.7-.9-1.1-1.6-1.1l-.5.1M152 3.4c-.7 0-1.3.4-1.6 1.1l-46.3 101.6L57.8 4.5c-.2-.7-.9-1.1-1.6-1.1H1.7c-1 0-1.7.8-1.7 1.7v189c0 1 .8 1.7 1.7 1.7h37.5c1 0 1.7-.8 1.7-1.7V57.4l47.8 113.9c.2.7.8 1.1 1.5 1.2h27.7c.7 0 1.3-.4 1.6-1.1l47.8-113.9v136.7c0 1 .8 1.7 1.7 1.8h37.9c.9 0 1.7-.8 1.7-1.7V5.3c.1-.9-.6-1.8-1.6-1.9h-55zm146 0c-.7 0-1.4.4-1.6 1.1l-73.1 189c-.3.9.1 1.9 1 2.2.2.1.4.1.6.1h38.4l23.9-58.4L322.5 45l28.5 74.8c.3.9 1.3 1.4 2.1 1.1l33.5-10.9c.9-.3 1.4-1.3 1.1-2.2v-.1L348.5 4.4c-.2-.7-.9-1.1-1.6-1.1H298v.1zm117.5 96.1c0 60.6 46.1 99.8 102.4 99.8 31.1.5 60.8-12.6 81.5-35.9.3-.3.4-.7.5-1.2V85c0-.9-.7-1.7-1.7-1.7h-64c-1 0-13 33.5-13 33.5 0 1 .8 1.7 1.7 1.7h36.7V148c-11.7 9.6-26.4 14.8-41.6 14.7-34.9 0-60.3-26.8-60.3-63.2S483 36.3 518 36.3c13.6-.1 26.8 4.9 36.9 14.1.4.4 1.1.5 1.6.3l36.3-11.8c.9-.3 1.4-1.3 1.1-2.2-.1-.2-.1-.3-.2-.4C578.5 16.2 554.4 0 517.9 0c-56.2 0-102.4 38.6-102.4 99.5'
        style={{
          fill: 'url(#mag_00000166670571226290606660000011522640988944400310_)',
        }}
      />
      <path
        id='seguros'
        d='M327.4 283.5c-.6-.4-.9-1-.8-1.7 0-1.2.9-2.1 2-2.2h.1c.5 0 1 .2 1.3.5 3.3 3.1 7.7 4.7 12.2 4.6 5.3 0 8.6-2.7 8.6-6.6 0-3.6-1.9-5.6-10.1-7.4-8.9-1.9-13-4.9-13-11.3 0-6.1 5.3-10.6 12.7-10.6 4.4-.3 8.8 1 12.4 3.6.6.4.9 1.1 1 1.8 0 1.2-.9 2.1-2.1 2.1-.5 0-.9-.1-1.3-.4-2.9-2.2-6.4-3.4-10-3.4-5.1 0-8.2 2.7-8.2 6.3 0 3.7 1.9 5.8 10.6 7.6 8.7 1.8 12.6 5.1 12.6 11 0 6.7-5.5 11-13.3 11-5.4.1-10.6-1.8-14.6-5.3m38.9 5.1c-1.2 0-2.2-1-2.2-2.2v-34.5c0-1.2.9-2.2 2.1-2.2h24.1c1.1 0 2 .9 2 2s-.9 2-2 2h-21.9v13.3h19.4c1.1.1 1.9 1.1 1.8 2.2-.1.9-.8 1.7-1.8 1.8h-19.4v13.7h22.1c1.1 0 2 .9 2 1.9v.1c0 1.1-.9 2-2 2l-24.2-.1zm33.2-19.4c-.4-10.8 8.1-19.8 18.8-20.2h.6c4.8-.2 9.5 1.3 13.3 4.2.6.4.9 1.1.9 1.8.1 1.2-.8 2.2-2 2.2-.6 0-1.1-.2-1.5-.6-3-2.4-6.8-3.7-10.6-3.6-8.6 0-14.7 7.3-14.7 15.9 0 9.3 5.9 16.2 15.3 16.2 4.1 0 8-1.4 11.2-3.9v-9.7h-10.4c-1.1 0-1.9-.9-1.9-1.9 0-1.1.8-2 1.9-2h12.2c1.2 0 2.2 1 2.2 2.2v11.9c0 1.1-.5 2.1-1.5 2.7-4 3.1-9 4.7-14 4.8-12.2 0-19.7-8.9-19.7-20.1m44.3 3.2v-20.7c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v20.5c0 8.5 4.5 13.3 11.8 13.3 7.4 0 11.7-4.3 11.7-12.9v-20.9c0-1.2.9-2.2 2.1-2.2h.1c1.2 0 2.2 1 2.2 2.2v20.4c0 11.4-6.5 17.3-16.2 17.3s-16.1-6-16.1-17m42.6-20.5c0-1.2.9-2.2 2.1-2.2h14.5c4-.2 8 1.2 11 3.9 2 2.1 3.1 4.8 3 7.7 0 6.4-4.3 10.2-10.3 11.3l9.6 12.5c.4.4.7 1 .7 1.6-.1 1.2-1 2.1-2.2 2.2-.8 0-1.6-.5-2-1.2L502.1 273h-11.2v13.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2l.1-34.9zm16.3 17.7c5.8 0 10-3 10-8 0-4.9-3.7-7.7-9.9-7.7h-12v15.9l11.9-.2zm22-.3c0-10.9 8.8-19.7 19.7-19.7s19.7 8.8 19.7 19.7-8.8 19.7-19.7 19.7-19.7-8.8-19.7-19.7m34.9 0c.4-8.5-6.3-15.7-14.8-16.1h-.4c-8.4.1-15.2 7-15.2 15.4v.5c-.4 8.5 6.3 15.8 14.8 16.1h.5c8.4-.1 15.2-6.9 15.2-15.4 0-.1 0-.2-.1-.5m12.2 14.7c-.6-.4-.9-1-.8-1.7 0-1.2.9-2.1 2-2.2h.1c.5 0 1 .2 1.3.5 3.3 3.1 7.7 4.7 12.2 4.6 5.3 0 8.6-2.7 8.6-6.6 0-3.6-1.9-5.6-10.1-7.4-8.9-1.9-13-4.9-13-11.3 0-6.1 5.3-10.6 12.7-10.6 4.4-.2 8.8 1.2 12.3 3.8.6.4.9 1.1.9 1.8 0 1.2-.9 2.1-2.1 2.1-.5 0-.9-.1-1.3-.4-2.9-2.2-6.4-3.4-10-3.4-5.1 0-8.3 2.7-8.3 6.3 0 3.7 1.9 5.8 10.6 7.6 8.7 1.8 12.6 5.1 12.6 11 0 6.7-5.5 11-13.3 11-5.1.3-10.3-1.5-14.4-5.1'
        style={{
          fill: '#425161',
        }}
      />
    </svg>
  )
}

export default Mag
